import { useMemo } from "react";
import { Avatar, Badge } from "antd";
import { getInitials } from "../../../utils/utils";

const UserAvatar = ({ data, isName = true, count = 0, overflowCount = 0 }) => {

  const colors = [
    { color: "#00727D", bgColor: "#E5F1F2" }, //theme
    { color: "#7367F0", bgColor: "#E9E7FD" }, //purple
    { color: "#00BAD1", bgColor: "#D6F4F8" }, //blue
    { color: "#FF9F43", bgColor: "#FFF0E1" }, // yellow
    { color: "#28C76F", bgColor: "#DDF6E8" }, // green
    { color: "#FF4C51", bgColor: "#FFE2E3" }, // red
  ];

  const randomColor = useMemo(() => {
    if (!data?.profileImage) {
      const index = Math.floor(Math.random() * colors.length);
      return colors[index];
    }
    return null;
  }, [data?.profileImage]);

  if (!data) return null;

  return (
    <div className="flex items-center gap-3">
      <div>
        <Badge count={count} overflowCount={overflowCount}>
          <Avatar
            size="large"
            src={data?.profileImage}
            className="font-semibold uppercase"
            style={{
              color: !data?.profileImage ? randomColor?.color : "",
              backgroundColor: !data?.profileImage ? randomColor?.bgColor : "",
            }}
          >
            {getInitials(data?.name)}
          </Avatar>
        </Badge>
      </div>

      {isName && <div>
        <p className="leading-none mb-1">{data?.name}</p>
        <p className="text-Gray leading-none">{data?.email}</p>
      </div>
      }

    </div>
  );
};

export default UserAvatar;
